<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.customerTags.addNewCustomerTag') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/tagi-klientow')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>

        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('settings.customerTags.addCustomerTag') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="tag-new-form" tag="form">
              <div class="form-group">
                <label for="name">
                  {{ $t('settings.customerTags.tagName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="name">
                  {{ $t('settings.customerTags.tagColor') }}:
                </label>

                <compact-picker
                  v-model="color" />
              </div>

              <div class="form-group">
                <label for="name">
                  {{ $t('settings.customerTags.tagDescription') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="description"
                  v-slot="{ errors }">
                  <d-textarea
                    :value.prop="description"
                    :state="errors.length ? 'invalid' : null"
                    v-model="description" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
          </d-tab>

          <d-tab :title="$t('settings.customerTags.translations')">
            <p class="text-center">
              {{ $t('settings.customerTags.addingTranslationsAvailableAfterSave') }}
            </p>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import { Compact } from 'vue-color';

export default {
  name: 'tag-new',
  components: {
    'compact-picker': Compact,
  },
  data () {
    return {
      name: '',
      color: '#000000',
      description: ''
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['tag-new-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customers/tags/store',
        formData: {
          name: this.name,
          color: this.color.hex ? this.color.hex : this.color,
          description: this.description
        },
        successTitle: this.$t('settings.customerTags.addCustomerTagSuccessTitle'),
        successText: this.$t('settings.customerTags.addCustomerTagSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.customerTags.addCustomerTagErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/tagi-klientow')
        }
      });
    }
  }
};
</script>
